import { render, staticRenderFns } from "./XyInput.vue?vue&type=template&id=98265bc4&scoped=true&"
import script from "./XyInput.vue?vue&type=script&lang=js&"
export * from "./XyInput.vue?vue&type=script&lang=js&"
import style0 from "./XyInput.vue?vue&type=style&index=0&id=98265bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98265bc4",
  null
  
)

export default component.exports